import { lazy, Suspense } from 'react'
import CurveWalletGate from '@/components/CurveWalletGate'
import { getPresaleFactoryAddress, isOnChainPresaleEnabled, shortenAddress } from '@/lib/launchpad/contracts'
import { CREATOR_SHARE_BPS, PLATFORM_SHARE_BPS, TRADE_FEE_BPS } from '@/lib/launchpad/constants'
import { PRESALE_FEE_BPS, PRESALE_LAUNCH_FEE_ETH, formatBps } from '@/lib/protocol'

const GatedCreatePresaleForm = lazy(() => import('@/components/GatedCreatePresaleForm'))

function CreateSimPresaleForm() {
  const factory = getPresaleFactoryAddress()
  const onChain = isOnChainPresaleEnabled()

  return (
    <div className="space-y-5">
      <div className="rounded-2xl border border-orange-400/20 bg-orange-400/5 p-4 text-xs leading-relaxed text-zinc-400">
        Set token name, ticker, and supply. Tokens per ETH and listing rate are derived from supply ÷ hard cap. Choose Live now (opens in 20 minutes, the factory floor) or Schedule a later start and end. createPresale sends those timestamps on-chain with the derived rates and ETH creatorPct. Penguin Pad takes
        {' '}
        {formatBps(PRESALE_FEE_BPS)}
        {' '}
        of ETH raised. Remaining ETH splits on the LP meter (70–100%). Contribute is only open during the start/end window. Withdraw stays open until close, or after a creator cancel.
        {' '}
        {onChain
          ? `Factory ${shortenAddress(factory ?? '')} is live. Protocol rule is ${PRESALE_LAUNCH_FEE_ETH} ETH; your wallet pays the current factory launchFee() with payable createPresale. Cancel in the wallet and nothing is created.`
          : 'Presale factory address is not set, so this still simulates locally after you connect on Robinhood Chain.'}
        {' '}
        After the raise lists, your token trades from the same pool as a Quick Launch: every buy and sell pays a
        {' '}
        {formatBps(TRADE_FEE_BPS)}
        {' '}
        trade fee, split
        {' '}
        {formatBps(CREATOR_SHARE_BPS)}
        {' '}
        creator /
        {' '}
        {formatBps(PLATFORM_SHARE_BPS)}
        {' '}
        platform. After listing, that creator share is disbursed to your wallet on every Uniswap swap — no separate claim step.
      </div>
      <CurveWalletGate actionLabel="Open a presale">
        {wallet => (
          <Suspense fallback={<p className="text-center text-xs text-zinc-500">Loading create form…</p>}>
            <GatedCreatePresaleForm wallet={wallet} />
          </Suspense>
        )}
      </CurveWalletGate>
    </div>
  )
}

export default CreateSimPresaleForm
